module.exports = __webpack_public_path__ + "img/img.ccefbf27.png";